// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';
// hooks
// components
import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section-new';
//
import { useAuthContext } from 'src/auth/hooks/';
import { NavToggleButton } from '../../_common';
import { NAV } from '../../config-layout';
import { NavSuperAdminConfig, NavSiteAdminConfig, NavOrgAdminConfig, NavIndividualUserConfig, NavOrgUserConfig } from './config-navigation';
import { ROLES } from 'src/utils/constants/constants';
import { dispatch } from 'src/redux/store';
import { fetchUserById } from 'src/redux/slices/user';
import { useEffect, useState } from 'react';
import { routePrefix } from 'src/utils/methods/StandardMethods';


// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useAuthContext();
  const [currentUser, setCurrentUser] = useState<any>();
  useEffect(() => {
    const orgCode = routePrefix(user);
    dispatch(fetchUserById(user?.id, orgCode))
      .then((res) => {
        setCurrentUser(res.user)
      })
      .catch((err) => console.log(err));
  }, []);

  const renderSwitch = (role: string | undefined) => {
    switch (role) {
      case ROLES.SUPER_ADMIN:
        return NavSuperAdminConfig(user);
      case ROLES.SITE_ADMIN:
        return NavSiteAdminConfig(user);
      case ROLES.ORG_ADMIN:
        return NavOrgAdminConfig(user);
      case ROLES.ORG_USER:
        return NavOrgUserConfig(user);
      case ROLES.INDIVIDUAL_USER:
        return NavIndividualUserConfig(user);
      default:
        return NavSuperAdminConfig(user);
    }
  }
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI + 'rem' },
      }}
    >
      <NavToggleButton
        sx={{
          // top: 22,
          left: `${NAV.W_MINI - 1}rem`,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI + 'rem',
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ maxWidth: '7rem' }} />
        {/* <Box sx={{ mt: 8, ml: 4, mb: 1 }} /> */}

        <NavSectionMini data={renderSwitch(user?.role?.name)} config={{ currentRole: user?.role?.name || 'Super Admin' }} />
      </Stack>
    </Box>
  );
}


// // @mui
// import { Stack, Box } from '@mui/material';
// // config
// import { NAV } from '../../../config-global';
// // utils
// import { hideScrollbarX } from '../../../utils/cssStyles';
// // components
// import Logo from '../../../components/logo';
// import { NavSectionMini } from '../../../components/nav-section';
// //
// import { navAdminConfig, navUserConfig } from './config-navigation';
// import NavToggleButton from './NavToggleButton';
// import { useAuthContext } from 'src/auth/hooks';

// // ----------------------------------------------------------------------

// export default function NavMini() {
//   const { user } = useAuthContext();
//   return (
//     <Box
//       component="nav"
//       sx={{
//         flexShrink: { lg: 0 },
//         width: { lg: NAV.W_DASHBOARD_MINI },
//       }}
//     >
//       <NavToggleButton
//         sx={{
//           top: 90,
//           left: NAV.W_DASHBOARD_MINI - 12,
//         }}
//       />

//       <Stack
//         sx={{
//           top: 65,
//           pb: 2,
//           height: 1,
//           position: 'fixed',
//           width: NAV.W_DASHBOARD_MINI,
//           borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
//           ...hideScrollbarX,
//         }}
//       >
//         {/* <Logo sx={{ mx: 'auto', my: 2 }} /> */}

//         {user?.role?.name === 'Admin' ? <NavSectionMini data={navAdminConfig} /> : <NavSectionMini data={navUserConfig} />}
//       </Stack>
//     </Box>
//   );
// }
